<section
  class="flex flex-col overflow-hidden rounded-xl border border-primary/20 bg-primary-container/40"
>
  <div class="flex flex-wrap items-start gap-4 p-6">
    <span
      class="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary text-on-primary"
    >
      <mat-icon>redeem</mat-icon>
    </span>

    <div class="flex min-w-64 flex-1 flex-col gap-3">
      <div>
        <h2 class="font-medium text-on-primary-container">
          Doporučte Mapu výuky další škole a získejte {{ discount }}% slevu pro obě školy
        </h2>
        <p class="mt-1 text-sm leading-relaxed text-on-surface-variant">
          Doporučená škola v objednávkovém formuláři na webu zaškrtne „Doporučila nás jiná škola“ a
          uvede název a IČO vaší školy a kontaktní osobu (jméno, e-mail, telefon). Škola získá
          {{ discount }} % na první roční licenci, vy {{ discount }} % na to příští období — a za
          každou další doporučenou školu o jedno období navíc.
        </p>
      </div>

      <div class="flex flex-wrap items-center gap-2">
        <a matButton="filled" [href]="programUrl" target="_blank" rel="noopener">
          <mat-icon>open_in_new</mat-icon>
          Program doporučení na webu
        </a>
        <button
          matButton
          type="button"
          [attr.aria-expanded]="conditionsOpen()"
          (click)="toggleConditions()"
        >
          Podmínky
          <mat-icon class="transition-transform" [class.rotate-180]="conditionsOpen()">
            expand_more
          </mat-icon>
        </button>
      </div>
    </div>

    <button
      type="button"
      matIconButton
      class="shrink-0"
      aria-label="Skrýt"
      title="Skrýt"
      (click)="dismiss()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  @if (conditionsOpen()) {
    <ul
      class="flex list-disc flex-col gap-1.5 border-t border-primary/20 bg-surface py-4 pr-6 pl-10 text-sm leading-relaxed text-on-surface-variant"
    >
      <li>Doporučovat může škola s aktivní placenou licencí START nebo PREMIUM.</li>
      <li>
        Doporučenou školou je škola, která dosud neměla objednávku ani zkušební období. Pokud začne
        zkušební licencí, nárok na slevu jí zůstává a uplatní se při přechodu na placený tarif.
      </li>
      <li>
        Slevy se vztahují na cenu licence a nesčítají se — v jednom ročním období lze uplatnit
        nejvýše {{ discount }} %. Sleva za doporučení nahrazuje zaváděcí slevu 15 %. Za každou další
        doporučenou školu získáte {{ discount }} % na jedno další roční období.
      </li>
      <li>
        Doporučení je třeba uvést při objednávce nové školy, nejpozději do uhrazení její licence.
        Poté je nelze uplatnit zpětně.
      </li>
    </ul>
  }
</section>
